import React from 'react';
import './header.css';  // CSS dosyasını import ediyoruz

function Header() {
  return (
    <header className="header">
      <h1>Marka Adı</h1>
    </header>
  );
}

export default Header;
